export function organicSource(source: string | null, host: string | null, paid = false): "organic_search" | "ai_assistant" | null {
  if (paid) return null;
  const s = (source || "").toLowerCase();
  const h = (host || "").toLowerCase();
  if (/^(chatgpt|openai|perplexity|claude|gemini|copilot|grok)(\.com|\.ai)?$/.test(s)) return "ai_assistant";
  const matches = (domain: string) => h === domain || h.endsWith(`.${domain}`);
  if (["chatgpt.com", "chat.openai.com", "perplexity.ai", "claude.ai", "gemini.google.com", "copilot.microsoft.com", "grok.com", "x.ai"].some(matches)) return "ai_assistant";
  if (["bing.com", "duckduckgo.com", "search.yahoo.com", "ecosia.org", "search.brave.com"].some(matches) || /(^|\.)google\.(com|[a-z]{2}|co\.[a-z]{2}|com\.[a-z]{2})$/.test(h)) return "organic_search";
  if (["google", "bing", "duckduckgo", "yahoo", "ecosia", "brave"].includes(s)) return "organic_search";
  return null;
}